export default __webpack_public_path__ + "static/media/exclusive.18a4d205.svg";